import React from 'react';
import { Stack } from '@mui/material';
import { Navigate } from 'react-router-dom';
import PageLayout from '@shared/shell/Layout/PageLayout';
import { DashboardTutorial } from '@features/tutorial';
import DashboardSummaryCards from './kpi';
import DashboardIncomingShipments from './purchase-orders';
import DashboardProductTable from './products';
import DashboardTasksSidebar from './tasks';
import DashboardActiveImports from './DashboardActiveImports';
import { useTutorialStore } from '../../../application/store';
import Referral from './referral/referral';

const DashboardHome: React.FC = () => {
  const { completed, unlockDashboardCompleted } = useTutorialStore();

  if (unlockDashboardCompleted === false) {
    return <Navigate to="/dashboard/onboarding" replace />;
  }

  return (
    <PageLayout title="Dashboard">
      <Stack direction="row" gap={4}>
        <Stack gap={3} flex={3} minWidth={0}>
          <DashboardSummaryCards />
          {/* <DashboardForecastChart /> */}
          <DashboardIncomingShipments />
          <DashboardProductTable />
        </Stack>

        <Stack
          display={{ md: 'none', lg: 'flex' }}
          position="sticky"
          top={0}
          width={{ lg: 350, xl: 458 }}
          gap={3}
        >

          {!completed && (
            <DashboardTutorial />
          )}

          {completed && (
            <DashboardTasksSidebar />
          )}

          <DashboardActiveImports />

          {completed && (
            <Referral />
          )}
        </Stack>
      </Stack>
    </PageLayout>
  );
};

export default DashboardHome;